import { Component, createRef } from "react";
import { IBaseComponentProps, NSBox, NSInfoProps, NSLabel, NSRepeater, NSRow } from "namirasoft-site-react";
import RuleLine from "./RuleLine";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchProps } from "../BillWatchProps";

export interface RulesProps extends IBaseComponentProps, NSARouterMakerResult, BillWatchProps
{
	info?: NSInfoProps;
}

export default class Rules extends Component<RulesProps>
{
	NSRepeater_Rules = createRef<NSRepeater<RuleLine, string>>();

	override render()
	{
		return (
			<NSRow style={{ width: NSBox.width.double }}>
				<NSLabel
					title="This configuration uses a logical OR among rules."
					description="Multiple rules are evaluated independently, and the condition connecting them is a logical OR. This means that only one If any of the rules detect unusual behavior based on their individual criteria, the system immediately considers the overall result to be anomalous and will generate a notification."
				>
					{
						this.props.info &&
						<a href={this.props.info.link} target='_blank' rel="noreferrer" style={{ marginLeft: "4px" }}>Read More</a>
					}
				</NSLabel>
				<NSRepeater<RuleLine, string>
					ref={this.NSRepeater_Rules}
					title="Rules"
					required
					min={1}
					createItem={(gIndex: number, lIndex: number, ref: React.RefObject<RuleLine>, onChange: () => void, onDelete: undefined | ((index: number) => void)) =>
					{
						return <RuleLine
							ref={ref}
							{...this.props}
							key={`${this.props.name}_Rules_NSRepeater_RulesLine_key_${gIndex}`}
							index={lIndex}
							deletable={true}
							onChanged={() =>
							{
								onChange();
							}}
							onDelete={() =>
							{
								onDelete?.(lIndex);
							}}
						/>;
					}}
					isEmpty={function (_, value: string | null): boolean
					{
						return !RuleLine.IS_DIRTY(value);
					}}
					getValue={function (item: RuleLine, checkError: boolean): string
					{
						return item.getValue(checkError);
					}}
					setValue={function (item: RuleLine, _: number, value: string | null): void
					{
						if (value)
							item.setValue(value);
					}}
					style={{ width: "100%", maxWidth: NSBox.width.double }}
				/>
			</NSRow>
		);
	}
}